<template>
	<div class="bigbox cursorstyleObjBtn">
		<!-- <div class="bannder">
		</div> -->
		<div class="nav cursorstyleObjBtn">
			当前位置：<span @click="userObj.routeClick('3')" class="navBoxTxt"> 首页 </span> >
					<span @click="userObj.routeClick('1')" class="navBoxTxt">申请管理</span> >
					我的软著
		</div>
		<p class="title">我的软著</p>
		<div style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
							软著名称：
						</div>
						<div class="inputclass">
							<el-input placeholder="请输入软著名称" v-model="SubmitObj.name"></el-input>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
              提交方式：
						</div>
						<div class="inputclass">
							<el-select v-model="SubmitObj.create_type" placeholder="请选择">
								<el-option v-for="item in userObj.configInterface().create_type"  v-if="item.value != 3"  :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
							软著性质：
						</div>
						<div class="inputclass">
							<el-select v-model="SubmitObj.nature" placeholder="请选择">
								<el-option v-for="item in userObj.configInterface().nature" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
							申请状态：
						</div>
						<div class="inputclass">
							<el-select v-model="SubmitObj.status" placeholder="请选择">
								<el-option v-for="item in userObj.configInterface().status" :key="item.value" :label="item.label"
									:value="item.value">
								</el-option>
							</el-select>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div style="margin-top: 20px;">
			<el-row :gutter="20">
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
							提交时间：
						</div>
						<div class="inputclass">
							<el-date-picker v-model="SubmitObj.create_time" value-format="yyyy-MM-dd"  format="yyyy-MM-dd" type="date" placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
				</el-col>
				<el-col :span="6">
					<div class="grid-content bg-purple">
						<div class="">
							授权时间：
						</div>
						<div class="inputclass">
							<el-date-picker v-model="SubmitObj.pass_time" type="date" value-format="yyyy-MM-dd"  format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</div>
					</div>
				</el-col>
				<el-col :span="12">
					<div class="grid-content bg-purple ">
						<div class="btn1 cursorstyleObjBtn" @click="btnquery()">
							查询
						</div>
						<div class="btn2 cursorstyleObjBtn" @click="applicationBtnBtn()">
							软著录入
						</div>
						<div class="btn3 cursorstyleObjBtn"  @click="applicationBtn()">
							软著申请
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 表单 -->
		<div class="tablebox">
			<el-table :data="tableData">
				<el-table-column label="序号" align="center" width="100px" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{scope.$index+1}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="软著名称" align="center" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="提交方式" align="center">
					<template slot-scope="scope">
						<span v-if="scope.row.create_type == '2'">自主录入</span>
						<span v-if="scope.row.create_type == '1'">自主申请</span>
						<span v-if="scope.row.create_type == '3'">后台录入</span>
					</template>
				</el-table-column>
				<el-table-column prop="nature_txt" label="软著性质" align="center" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="status_txt" label="状态" align="center" show-overflow-tooltip>
				</el-table-column>
				<el-table-column label="提交日期" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{userObj.dateFormat(scope.row.create_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="授权日期" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						<span>{{userObj.dateFormat(scope.row.pass_time)}}</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="130px" show-overflow-tooltip>
					<template slot-scope="scope">
						<el-button v-if="scope.row.status != 8 || scope.row.is_ok == 1" @click="SeePatent(scope.row)" type="text" size="small">查看</el-button>
						<el-button v-if="scope.row.status == 2|| scope.row.status ==5" @click="editPatent(scope.row)" type="text" size="small">编辑</el-button>
						<el-button v-if="scope.row.status == 2" type="text" size="small" @click="openDeletePatent(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="fenye">
			<!-- 分页 -->
			<el-pagination background :page-size="10" layout=" prev, pager, next, jumper" :total="this.total_count"
				:current-page="SubmitObj.page_num" @current-change="handleCurrentChange">
			</el-pagination>
		</div>
	</div>
</template>

<script>
	import {
		GetlistSoftwareInterface,
		DeleteSoftwareInterface
	} from "@/api/ApplicationManagement.js"
	export default {
		data() {
			return {
				//创建方式
				ProfessionalType: [{
					value: '000',
					label: '全部'
				}, {
					value: '1',
					label: '自主录入'
				}, {
					value: '2',
					label: '自主申请'
				}],
				// 性质
				CreationMethod: [{
					value: '000',
					label: '全部'
				}, {
					value: '1',
					label: '个人'
				}, {
					value: '2',
					label: '企业'
				}, {
					value: '3',
					label: '党政府'
				}
				],
				// 申请状态
				ApplicationStatus: [{
					value: '000',
					label: '全部'
				}, {
					value: '3',
					label: '审核中'
				}, {
					value: '4',
					label: '被驳回'
				}, {
					value: '5',
					label: '补充材料'
				}, {
					value: '6',
					label: '国家知识产权平台审核'
				}, {
					value: '7',
					label: '已授权'
				},
				{
					value: '2',
					label: '待提交'
				},
				],
				// 表单
				tableData: [],
				// 总条数
				total_count: null,
				// 总页数
				total_page: null,
				SubmitObj: {
					// 专利名称
					name: '',
					// 创建方式
					create_type:'',
					// 类型
					nature: '',
					// 状态
					status: '',
					// 提交时间
					create_time: '',
					//授权时间
					pass_time: '',
					// 页数
					page_num: 1,
					// 条数
					page_size: 10,
				}
			}
		},
		mounted() {
			this.GetlistPatent(1)
		},
		methods:{
			applicationBtn() {
				// this.$router.push('./SoftApply')
				this.$router.push({path:'./SoftApply'})
			},
      applicationBtnBtn() {
        this.$router.push({path:'SoftApplyEnter',query:{create_type:'2'}})
      },
			//获取列表
			async GetlistPatent(vlaue) {
				let obj
				// 初始化状态
				if (vlaue == '1') {
					obj = {
						page_size:10
					}
				}
				// 查询获取的列表
				else if (vlaue == "2") {
					// 创建方式
					if (this.SubmitObj.create_type == '000') {
						this.$delete(this.SubmitObj, 'create_type')
					}
					// 商标所属
					if (this.SubmitObj.nature == '000') {
						this.$delete(this.SubmitObj, 'nature')
					}
			
					// 申请状态
					if (this.SubmitObj.status == '000') {
						this.$delete(this.SubmitObj, 'status')
					} 
					// 创建时间
					if (this.SubmitObj.create_time == '') {
						this.$delete(this.SubmitObj, 'create_time')
					}
					//授权时间
					if (this.SubmitObj.pass_time == '') {
						this.$delete(this.SubmitObj, 'pass_time')
					}
					obj = this.SubmitObj
				}
			
				let res = await GetlistSoftwareInterface(obj)
				if (res.code == "00000") {
					this.tableData = res.data.result
					this.total_count = res.data.total_count
				}
			},
			//删除列表
			async DeletePatent(vlaue) {
				let obj = {
					id:vlaue.id
				}
				let res = await DeleteSoftwareInterface(obj)
        if(res.code == "00000"){
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.GetlistPatent("2")

        }else {
          this.$message({
            type: 'success',
            message: res.msg
          });
        }
			},
      openDeletePatent(vlaue) {
        this.$confirm('此操作将永久删除该, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.DeletePatent(vlaue)

        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
			// 查询
			btnquery() {
				this.SubmitObj.page_num = 1
				this.GetlistPatent("2")
			},
			// 分页
			handleCurrentChange(val) {
				this.SubmitObj.page_num = val
				this.GetlistPatent("2")
			},
			// 查看列表
			SeePatent(vlaue){
				// this.$router.push({path:'./SoftApply',query:{mark:'see',ids:vlaue.id}})
				this.$router.push({path:'./softSeeMore_seeObj',query:{mark:'see',ids:vlaue.id}})
			},
			// 编辑
			editPatent(vlaue){
				this.$router.push({path:'./SoftApply',query:{mark:'edit',ids:vlaue.id}})
			},
		}
	}
</script>

<style scoped="scoped" lang="less">
	.bigbox {
		width: 63vw;
		margin: 0 auto;
		// border: 1px red solid;
	}
	
	.bannder {
		width: 100%;
		height: 326px;
		background: #D8D8D8;
		margin: 0 auto;
		margin-top: 14px;
	}
	
	.nav {
		margin-top: 14px;
		font-size: 1rem;
		color: #333333;
	}
	
	.title {
		font-size: 1.12rem;
		font-weight: bold;
		color: #333333;
		margin-top: 10px;
	}
	
	.el-row {
		margin-bottom: 20px;
	
		&:last-child {
			margin-bottom: 0;
		}
	}
	
	.el-col {
		// border-radius: 4px;
	}
	
	.bg-purple-dark {
		background: #99a9bf;
	}
	
	.bg-purple {
		// background: #d3dce6;
	}
	
	.bg-purple-light {
		// background: #e5e9f2;
	}
	
	.grid-content {
		// border-radius: 4px;
		min-height: 28px;
		display: flex;
		color: #333333;
		line-height: 19px;
		font-size: 0.88rem;
		line-height: 28px;
	
	}
	
	.row-bg {
		// padding: 10px 0;
		// background-color: #f9fafc;
	}
	
	/deep/.el-input__inner {
		width: 10.5vw;
		height: 28px;
		border-radius: 5px;
		border: 1px solid #E5E5E5;
	}
	
	/deep/.el-input input::-webkit-input-placeholder {
		color: #A0A0A0;
		font-size: 0.88rem;
	}
	
	/deep/.el-input__icon {
		line-height: 28px;
	}
	
	/deep/.el-date-editor.el-input {
		width: 10.5vw;
	}

	// 按钮
	.btn1 {
		width: 56px;
		height: 28px;
		background: #094AAE;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;

	}

	.btn2 {
		width: 82px;
		height: 28px;
		background: #8F5400;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		margin-left: 10px;
	}

	.btn3 {
		width: 82px;
		height: 28px;
		background: #4D8F00;
		border-radius: 5px;
		color: #FFFFFF;
		font-size: 14px;
		text-align: center;
		margin-left: 10px;
	}


	/* table */
	.tablebox {
		// width: 1068px;
		margin: 0 auto;
		margin-top: 20px;
		border-top: 1px solid #E5E5E5;
		border-right: 1px solid #E5E5E5;
		border-left: 1px solid #E5E5E5;
	}

	/deep/.el-table__header th {
		padding: 0;
		line-height: 40px;
		height: 40px;
		background: #D8D8D8;
		font-weight: bold;
		color: #333333;
		font-size: 14px;

	}

	/deep/ .el-table__body td {
		padding: 0;
		height: 40px;
		line-height: 40px;
		color: #333333;
		font-size: 14px;
	}

	.btnbox {
		width: 100%;
		border-top: 1px solid #E5E5E5;
		padding: 10px;

		div {
			margin-left: 20px;
		}
	}


	.fenye {
		float: right;
		margin-right: 40px;
	}

	.el-pagination {
		margin-top: 10px;
		margin-bottom: 10px;
	}

	/deep/.el-pagination .el-select .el-input .el-input__inner {
		width: 100px !important;
		margin: 0 5px !important;
	}

	/deep/.el-pagination__editor.el-input .el-input__inner {
		width: 50px;
	}
</style>
